import { getAPIFromDomain } from "../../lib/api";
import { stringify } from "query-string";
import { Storage } from "@secondcloset/types";

export const fetchProductIndex = async (query: Record<string, unknown>): Promise<Storage.Product[]> => {
  const api = getAPIFromDomain();
  const url = `/products${query ? "?" + stringify(query) : ""}`;
  const res = await api.get(url);
  return res.data;
};
